export const ESPOT_NAME =
  'SHOPPING_PREFERENCES_SUMMARYANDPAYMENT_PAGE_BOTTOM_ESPOT';
export const PROMO_CLICK = 'promoClick';
